import { cssBreakpoints } from '@coverflex-tech/hypernova';
import { globalStyle, style } from '@vanilla-extract/css';

const grid = style({
  margin: '0 auto',
});

globalStyle(`${grid}:has(> :nth-child(2))`, {
  '@media': {
    [`screen and (min-width: ${cssBreakpoints.xlMin})`]: {
      width: '150%',
      marginLeft: '-25%',
      justifyContent: 'center',
    },
  },
});

export const css = { grid };
